import { useQuery, useQueryClient, keepPreviousData } from "@tanstack/react-query";
import { coursesApi } from "api/courses/coursesApi";

export const useCourse = (courseId?: number | null, refetchOnWindowFocus: boolean = true) => {
  const queryClient = useQueryClient();
  const { isLoading, data, refetch } = useQuery({
    queryKey: ["courseById", courseId],
    queryFn: () => coursesApi.fetchById(courseId!),
    enabled: !!courseId,
    refetchOnWindowFocus,
    placeholderData: keepPreviousData,
  });
  const invalidate = () => {
    return queryClient.invalidateQueries({
      queryKey: ["courseById", courseId],
    });
  };

  return { loading: isLoading, data: data?.data, refresh: refetch, invalidate };
};
